
import { useQuery } from '@tanstack/react-query';
import { fetchData } from './fetchData';

/**
 * A single, generic hook to fetch data from any endpoint,
 * using React Query under the hood.
 *
 * @param {string} endpoint - e.g. '/api/users'
 * @param {object} config - optional React Query config (including suspense)
 */
export function useData(endpoint, config = {}) {
  return useQuery([endpoint], () => fetchData(endpoint), {
    // Turn on Suspense by default if you want
    suspense: true,
    // Customize retry, refetch intervals, etc. here or from the caller
    retry: 3,
    ...config,
  });
}
